module.exports = __webpack_public_path__ + "img/youtube.243796f3.svg";